// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3rdnN","modalFooterButton":"ModalNotes_modalFooterButton__FLCAq"};